import { handleDispatchResult } from '@wajeez-web/core/utils';
import { store } from '@wajeez-web/stores/base';

import { getContentEntityStructuresLookupsAsync } from './slices';

export const getContentEntityStructuresLookups = async (
  data: { languageId?: string },
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    getContentEntityStructuresLookupsAsync(data)
  );

  return handleDispatchResult(res, onSuccess);
};
